<template>
  <div class="card-new" style="max-height: 33rem">

    <div class="card-header" style="padding-bottom: 0">
      <div class="flex flex-row divide-x divide-slate-100">
        <div
            :class="current === 'shipagent' && viewAll ? 'text-slate-800 bg-white' : 'text-slate-700 bg-slate-100 cursor-pointer hover:bg-white'"
            @click.prevent="switchView('shipagent')"
            class="py-3 px-4 text-xs text-center w-1/2 rounded-tl-xl">
          View Shipping Agents
        </div>
        <div
            :class="current != 'shipagent' && viewAll ? 'text-slate-800 bg-white' : 'text-slate-700 bg-slate-100 cursor-pointer hover:bg-white'"
            @click.prevent="switchView('clearingagent')"
            class="py-3 px-4 text-xs text-center w-1/2 rounded-tr-xl">
          View Clearing Agents
        </div>
      </div>

    </div>
    <div class="card-content" v-if="viewAll">


      <div v-if="current === 'shipagent' && viewAll ">

        <div v-if="loading" class="w-full my-2">
          <div>
            <p class="text-center text-lg">
              <i class="fad fa-spinner fa-spin"></i>
            </p>
          </div>
        </div>
        <div class="w-full 48 overflow-auto dashboard-scroll" style="height: 28.5rem">
          <p class="text-right text-xs">Total: {{ result.length }}</p>
          <div v-for="item in result" v-bind:key="item.pos">
            <div class="agent-card mb-2 border-b border-slate-300 pb-3">
              <div class="flex content-center">
                <div
                    class="rounded-full mt-2 bg-blue-200 font-semibold text-slate-600 h-12 w-12 flex items-center justify-center"
                >
                  {{ item.name.charAt(0) }}
                </div>
                <div class="h-16 flex flex-wrap content-center pl-3 ...">
                  <div>
                    <p class="text-xs">
                      {{ item.name }}
                    </p>
                    <p class="text-xs" v-if="item.phone">
                      +{{ item.phone }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="current === 'clearingagent' && viewAll ">
        <div v-if="loading" class="w-full my-2">
          <div>
            <p class="text-center text-lg">
              <i class="fad fa-spinner fa-spin"></i>
            </p>
          </div>
        </div>
        <div class="w-full overflow-auto dashboard-scroll" style="height: 28rem">
          <p class="text-right text-xs">Total: {{ clearingagents ? clearingagents.length : 0 }}</p>
          <div v-for="item in clearingagents" v-bind:key="item.pos">
            <div class="agent-card mb-2 border-b border-slate-300 pb-3">
              <div class="flex content-center">
                <div
                    class="rounded-full mt-2 bg-blue-200 font-semibold text-slate-600 h-12 w-12 flex items-center justify-center"
                >
                  {{ item.name.charAt(0) }}
                </div>
                <div class="h-16 flex flex-wrap content-center pl-3 ...">
                  <div>
                    <p class="text-xs">
                      {{ item.name }}
                    </p>
                    <p class="text-xs" v-if="item.phone">
                      +(960) {{ item.phone }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Vue} from "vue-property-decorator";
import BandharuService from "@/services/bandharu.service";

@Component({
})
export default class ShippingAgents extends Vue {
  private service = new BandharuService();

  private settings = {
    userDropdown: false,
    notificationDropdown: false,
  };

  private loading = false;

  private result = [];
  private searchResult = null;
  private clearingagents = [];
  private current = "shipagent";
  private searchAgent = "";
  private viewAll = false;

  private form = {
    container: "",
  };

  resetResults() {
    this.result = [];
  }

  mounted() {
    this.getShippingAgents();
  }

  shuffle(array: any) {
    let currentIndex = array.length, temporaryValue, randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {

      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  }


  getShippingAgents() {
    this.loading = true;
    this.service
        .getShippingAgents()
        .then((res) => {
          this.result = res;
          this.result = this.shuffle(this.result);
          this.loading = false;
        })
        .catch((error) => {
          console.log("Error fetching shipping agnets");
          this.loading = false;
        });
  }

  getClearingAgents() {
    this.loading = true;
    this.service
        .getClearingAgents()
        .then((res) => {
          this.clearingagents = res;
          this.clearingagents = this.shuffle(this.clearingagents);
          this.loading = false;
        })
        .catch((error) => {
          console.log("Error");
          this.loading = false;
        });
  }

  switchView(name: string) {

    if (this.viewAll) {
      if (this.current === name) {
        this.viewAll = false;
        return;
      }
    }


    this.viewAll = true;
    this.current = name;

    if (name === "clearingagent") {
      this.getClearingAgents();
    }

    if (name === "shipagent") {
      this.getShippingAgents();
    }
  }

  viewUserDropdown() {
    this.settings.userDropdown = true;
  }

  hideUserDropdown() {
    this.settings.userDropdown = false;
  }

  viewNotifications() {
    this.settings.notificationDropdown = true;
  }

  hideNotifications() {
    this.settings.notificationDropdown = false;
  }
}
</script>
<style>


/* Hide scrollbar for Chrome, Safari and Opera */
.dashboard-scroll::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.dashboard-scroll {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

</style>
